import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { NICHE_PILLAR_MAP } from '../utils/niches';

interface InternalLinkCTAProps {
  niche?: string;
}

const InternalLinkCTA: React.FC<InternalLinkCTAProps> = ({ niche }) => {
  if (!niche) return null;

  const pillar = NICHE_PILLAR_MAP[niche];
  if (!pillar) return null;

  return (
    <div className="mt-8 bg-gradient-to-br from-accent-50 to-primary-50 rounded-2xl p-6">
      <Link
        to={pillar.path}
        className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 font-semibold text-lg transition-colors"
      >
        {pillar.ctaCopy}
        <ArrowRight className="w-5 h-5" />
      </Link>
    </div>
  );
};

export default InternalLinkCTA;
